import React from 'react';
import { AdvancedImage, lazyload, placeholder, responsive } from '@cloudinary/react';
import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';

interface Props {
  illustration: CloudinaryImageType;
}

export const Illustration = ({ illustration }: Props) => {
  const { getResponsiveImage } = useCloudinary();
  const mainImage = getResponsiveImage(illustration.publicId, {
    width: 600,
    height: 474,
    focusMethod: illustration?.focus,
    devicePR: 3.0,
    format: 'svg',
  });

  return (
    <StyledIllustration
      cldImg={mainImage}
      plugins={[
        lazyload({ rootMargin: '10px 20px 10px 30px', threshold: 0.25 }),
        responsive({ steps: 200 }),
        placeholder({ mode: 'blur' }),
      ]}
      alt={illustration.altText || illustration.caption}
    />
  );
};

const StyledIllustration = styled(AdvancedImage)`
  position: absolute;
  height: 474px;
  top: -110px;
  right: 0;
  @media (max-width: ${breakpoints.l}) {
    height: 300px;
    top: -100px;
  }
  @media (max-width: ${breakpoints.m}) {
    height: 184px;
    top: -80px;
  }
`;
